import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserResource } from "@shared/interfaces.ts";
import { useUser } from "@/contexts/UserContext.tsx";
import { Button } from "@/components/ui/button.tsx";
import { FormInput } from "@/components/FormInput.tsx";
import { Form } from "@/components/ui/form.tsx";
import useFormRequest from "@/hooks/useFormRequest.ts";

interface LoginFormInputs {
  meta: {
    contract_number: string;
    reference_number: string;
  };
}

interface LoginResponse {
  data: UserResource;
}

export default function LoginPage() {
  const { user, login } = useUser();
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const { loading, send, response, form } = useFormRequest<
    LoginFormInputs,
    LoginResponse
  >(
    "/folloportal/login",
    "POST",
    {
      meta: {
        contract_number: "",
        reference_number: "",
      },
    },
    (_resultData, data) => {
      sessionStorage.setItem("contract_id", data.meta.contract_number);
    }
  );

  useEffect(() => {
    if (response) {
      login(response.data, response?.data?.meta?.jwt_token ?? "");
    }
  }, [login, response]);

  useEffect(() => {
    form.clearErrors();
  }, [i18n.language]);

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [navigate, user]);

  return (
    <Form {...form}>
      <form
        onSubmit={send}
        className="h-full flex justify-center items-center flex-col mx-auto max-w-sm px-1.5"
      >
        <div className="text-2xl font-semibold leading-8 text-center">
          {t("fe.pages.login.title")}
        </div>
        <div className="text-sm text-muted-foreground text-center mt-2">
          {t("fe.pages.login.subtitle")}
        </div>
        <FormInput
          className="mt-6 w-full"
          form={form}
          label={t("fe.pages.login.contractNumber")}
          name="meta.contract_number"
          placeholder="Ex: 1234"
        />
        <FormInput
          className="mt-6 w-full"
          form={form}
          label={t("fe.pages.login.referenceNumber")}
          name="meta.reference_number"
          placeholder="Ex: 11-1111"
        />
        <Button
          className="mt-6 w-full cursor-pointer"
          color="primary"
          // isLoading={loading}
          // radius={"sm"}
          type={"submit"}
          disabled={loading}
        >
          {t("fe.pages.login.login")}
        </Button>
      </form>
    </Form>
  );
}
